import { useCallback } from "react";

import { useLibrary } from "../../providers";
import { useObjectMemo } from "../../hooks";

import type { FluentParams, OptionalIfEmpty } from "./l10n.types";

export const useL10n = () => {
  const t = useLibrary("translations");

  const typeSafeGetParams = useCallback((fl: FluentParams) => {
    return fl;
  }, []);

  const typeSafeGetString = useCallback(
    <TFId extends Fluent.ID>(
      id: TFId,
      vars?: OptionalIfEmpty<Fluent.Args<TFId>>,
      fallback?: string,
    ) => {
      return t.getString(id, vars, fallback);
    },
    [t],
  );

  return useObjectMemo({
    getParams: typeSafeGetParams,
    getString: typeSafeGetString,
  });
};

export type TypeSafeReactLocalization = ReturnType<typeof useL10n>;
